


import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

import MessageComponent from '@/shared/components/Message.vue';
import ErrorMessagesComponent from '@/shared/components/ErrorMessages.vue';
import LoaderComponent from '@/shared/components/Loader.vue';
import ResultsListComponent from './ResultsList/ResultsList.vue';

import LinkDirective from '@/shared/directives/link-directive';

@Component({
    components: {
        MessageComponent,
        ErrorMessagesComponent,
        LoaderComponent,
        ResultsListComponent
    },
    computed: {
        ...mapGetters([
            "config", 
            "results", 
            "loading", 
            "currentPage", 
            "resultsPerPage", 
            "totalResults", 
            "errors"])
    },
    directives: {
        LinkDirective
    }
})
export default class NewsComponent extends Vue {
}
